export interface IRGBA {
  r: number
  g: number
  b: number
  a: number // percentage
}

export class Color {
  r: number = 0
  g: number = 0
  b: number = 0
  a: number = 0

  constructor(input: IRGBA) {
    this.r = input.r
    this.g = input.g
    this.b = input.b
    this.a = input.a / 255
  }

  static fromRGBA(c: IRGBA) {
    return new Color(c)
  }

  toHex(alpha?: boolean) {
    const t = (v: number) => v.toString(16).toUpperCase()

    return (
      '#' + t(this.r) + t(this.g) + t(this.b) + (alpha ? t(this.a * 255) : '')
    )
  }

  toRgba() {
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`
  }

  darken(amount: number) {
    const r = Math.max(0, Math.min(255, this.r - (this.r * amount) / 100))
    const g = Math.max(0, Math.min(255, this.g - (this.g * amount) / 100))
    const b = Math.max(0, Math.min(255, this.b - (this.b * amount) / 100))
    return new Color({
      r: Math.floor(r),
      g: Math.floor(g),
      b: Math.floor(b),
      a: this.a * 255,
    })
  }
}
